exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search_box\n{\n    margin-bottom: 10px;\n    float: right;\n    height: 35px;\n    border-color: #3cd4f4;\n    border-radius: 9px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/users/admin/listusers/listusers.component.css
// module id = ../../../../../src/app/components/pages/users/admin/listusers/listusers.component.css
// module chunks = main